
import { REGION_ENVIRONMENT } from 'SharedDir/constants/common';
import { RegionEnv } from 'SharedDir/declarations/system/region-customization';
import { computed, defineComponent, onMounted, PropType, ref } from 'vue';

export type ShildType = 'brand' | 'gray';

export default defineComponent({
  components: {},
  props: {
    type: {
      required: true,
      type: String as PropType<ShildType>,
      default: 'brand',
    },
    text: {
      required: true,
      type: [String, Number],
      default: '1',
    },
    width: {
      required: false,
      type: Number,
      default: 41,
      // default: 100,
    },
    height: {
      required: false,
      type: Number,
      default: 39,
      // default: 100,
    },
    colorTextElement: {
      required: false,
      type: String,
      default: '#fff',
    },
  },

  setup(props) {
    const lengthText = computed(() => {
      return String(props.text).length;
    });

    const getY = ref('33');

    const colorShildMiniElement = ref('#007352');

    const colorShildElement = ref('#3DAB46');

    // Для корректной отрисовки двойных цифр
    const getX = computed(() => {
      return lengthText.value > 1 ? 3 : 11.5;
    });

    const cssProps = computed(() => {
      return {
        '--shild-text-color': props.colorTextElement,
      };
    });

    onMounted(() => {
      if (props.type === 'brand') {
        if (REGION_ENVIRONMENT === RegionEnv.YANAO) {
          colorShildMiniElement.value = '#0E8CCC';
          colorShildElement.value = '#0c7bb2';
        } else {
          colorShildMiniElement.value = '#007352';
          colorShildElement.value = '#3DAB46';
        }
      }
      if (props.type === 'gray') {
        colorShildMiniElement.value = '#828896';
        colorShildElement.value = '#3D4754';
      }
    });

    return {
      cssProps,
      props,
      lengthText,
      getX,
      getY,
      colorShildMiniElement,
      colorShildElement,
    };
  },
});
